import { atom } from 'jotai';

/** 상품 쿠폰을 적용한 대상. 같은 상품을 여러 개 담았을 때 몇 번째 상품인지(units)까지 구분한다 */
export interface ItemCouponTarget {
    itemKey: string;
    /** 쿠폰이 차지하는 상품 단위 번호 (0부터). 1+1 쿠폰은 2개 */
    units: number[];
}

/**
 * 쿠폰 페이지에서 고른 상품 쿠폰 초안. couponId → 적용 대상.
 * 적용할 상품 모달(ItemCouponTargetBottomSheet)과 주고받는다.
 */
export const itemCouponDraftAtom = atom<Record<string, ItemCouponTarget>>({});
